import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const dashHref =
    user?.role === "admin"
      ? "/admin"
      : user?.role === "contractor"
      ? "/contractor"
      : "/customer";

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="bg-bone border-b-2 border-ink sticky top-0 z-40">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-12 py-4">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <div className="w-9 h-9 bg-ink text-acid font-display font-black text-xl flex items-center justify-center border-2 border-ink">
            L
          </div>
          <div>
            <div className="font-display font-black text-xl uppercase tracking-tight leading-none">LeadTitan</div>
            <div className="overline text-[10px] leading-none mt-0.5">Pros / Customers / Made simple</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <Link to="/categories" className="overline hover:text-klein" data-testid="nav-categories">Categories</Link>
          <Link to="/pricing" className="overline hover:text-klein" data-testid="nav-pricing">Pricing</Link>
          {user ? (
            <Link to={dashHref} className="overline hover:text-klein" data-testid="nav-dashboard">Dashboard</Link>
          ) : (
            <Link to="/auth?mode=login" className="overline hover:text-klein" data-testid="nav-login">Sign In</Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 border-2 border-ink px-3 py-2 bg-white" data-testid="navbar-user">
                <User className="w-4 h-4" />
                <span className="font-mono text-xs uppercase tracking-widest">{user.name?.split(" ")[0]}</span>
                <span className="font-mono text-[10px] bg-acid border border-ink px-1.5">{user.role}</span>
              </div>
              <button onClick={handleLogout} className="brut-btn" data-testid="navbar-logout">
                <LogOut className="w-4 h-4 mr-1" /> Out
              </button>
            </>
          ) : (
            <>
              <Link to="/auth?mode=login" className="brut-btn" data-testid="navbar-signin">Sign in</Link>
              <Link to="/auth?mode=register" className="brut-btn-primary" data-testid="navbar-getstarted">Get started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
